module.exports = __webpack_public_path__ + "static/32-flatearth-october2009-935c7da31b2d6b50fba15430174f6a27.jpg";